import { jsx } from "panel";
import { BannerEl } from "common/components/banner";
import { BannerType } from "common/components/banner/types";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor } from "common/components/spinner/types";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { DisplayType, Placement } from "common/components/tooltip/types";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { FileUploaderEl } from "common/components/file-uploader";
import { ExpiresModeOptions, ExpiresUnit } from "common/types/reports/service-accounts";
import { AutocompleteType } from "common/components/input/types";
import { CopyToClipboardEl } from "../copy-to-clipboard";
export function template() {
  const { currentTab, error, isLoading, orgs, selectedOrg, serviceAccount, userFile, userRows } = this.state;
  const isServiceAccount = this.helpers.isServiceAccount();
  const isSingleProject = !!this.getProjectIdIfSingleProject();
  const modalHeader = isSingleProject ? `Invite` : `Invite New Users`;
  const InviteUsersRow = ({ row, idx }) => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-row"
  }, (() => {
    const isServiceAccount2 = this.helpers.isServiceAccount();
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column"
    }, isServiceAccount2 ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-title"
    }, "Name"), /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-input-container"
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: ".invite-users-service-account-name",
      attrs: {
        "error-message": row.nameErrorMsg,
        "validation-status": this.helpers.serviceAccountNameValidationStatus(row)
      },
      props: {
        value: row.name
      },
      on: {
        input: (ev) => this.helpers.updateServiceAccountName(ev, row)
      }
    }))) : /* @__PURE__ */ jsx(null, null, !idx ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-title"
    }, "Email Address") : null, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-input-container"
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: ".invite-users-input.invite-users-email-input",
      attrs: {
        type: `text`,
        autocomplete: AutocompleteType.InviteUsersAutocompleteOff
      },
      props: {
        value: row.email
      },
      on: {
        input: (ev) => this.helpers.updateUserEmail(ev, row),
        focus: this.helpers.clearErrors,
        blur: (ev) => this.helpers.updateEmailError(ev, row)
      }
    }), (row.emailError || row.emailInfo) && row === userRows.find((userRow) => userRow.email === row.email) ? /* @__PURE__ */ jsx(TooltipEl, {
      attrs: {
        "always-show": true,
        type: row.emailInfo ? DisplayType.Default : DisplayType.Error,
        placement: Placement.Left
      }
    }, (() => {
      const descriptor = row.email && row.email.length ? `a valid` : `an`;
      return row.emailErrorMsg || `Please enter ${descriptor} email address`;
    })()) : null))), /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column"
    }, !idx ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-title"
    }, "Organization Role") : null, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-input-container"
    }, /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        "selected-option": row.orgRole ? this.helpers.capitalize(row.orgRole) : `Select role`,
        "menu-height": 350,
        size: ButtonSize.Large
      },
      props: {
        sections: this.helpers.getOrgRoleSections()
      },
      on: {
        change: (ev) => this.helpers.selectOrgRole(ev, row),
        focus: this.helpers.clearErrors
      }
    })), row.orgRoleError && row === userRows.find((row2) => row2.orgRoleError) ? /* @__PURE__ */ jsx(TooltipEl, {
      attrs: {
        "always-show": true,
        type: DisplayType.Error,
        placement: Placement.Top
      }
    }, "Please select a role") : null), currentTab === this.helpers.TABS.PROJECT ? /* @__PURE__ */ jsx(null, null, !isSingleProject && /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column",
      style: { width: `250px` }
    }, (() => {
      const numProjects = row.projectIds.length;
      const projectPlural = this.helpers.pluralize(`project`, numProjects);
      return /* @__PURE__ */ jsx(null, null, !idx ? /* @__PURE__ */ jsx("div", {
        sel: ".invite-users-title"
      }, "Projects") : null, /* @__PURE__ */ jsx("div", {
        sel: ".invite-users-input-container"
      }, /* @__PURE__ */ jsx(SelectEl, {
        style: { width: `250px` },
        attrs: {
          "selected-option": numProjects ? `${numProjects} ${projectPlural}` : `Select projects`,
          multiple: true,
          "show-select-all": true,
          size: ButtonSize.Large,
          "menu-width": 250
        },
        props: {
          sections: this.helpers.getProjectSections(row)
        },
        on: {
          change: (ev) => this.helpers.toggleProjectSelected(ev, row),
          selectAll: (ev) => this.helpers.toggleAllProjectsSelected(ev, row),
          focus: this.helpers.clearErrors
        }
      })), row.projectError && row === userRows.find((row2) => row2.projectError) ? /* @__PURE__ */ jsx(TooltipEl, {
        attrs: {
          "always-show": true,
          type: DisplayType.Error,
          placement: Placement.Top
        }
      }, "Please select at least one project") : null);
    })()), /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column"
    }, !idx ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-title"
    }, "Project Role") : null, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-input-container"
    }, /* @__PURE__ */ jsx(SelectEl, {
      attrs: {
        "selected-option": row.projectRole ? this.helpers.capitalize(row.projectRole) : `Select role`,
        "menu-height": 300,
        size: ButtonSize.Large
      },
      props: {
        sections: this.helpers.getProjectRoleSections()
      },
      on: {
        change: (ev) => this.helpers.selectProjectRole(ev, row),
        focus: this.helpers.clearErrors
      }
    }), row.projectRoleError && row === userRows.find((row2) => row2.projectRoleError) ? /* @__PURE__ */ jsx(TooltipEl, {
      attrs: {
        "always-show": true,
        type: DisplayType.Error,
        placement: Placement.Right
      }
    }, "Please select a role") : null)), isServiceAccount2 && /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column.invite-users-expires-column"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-expires-container"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-title"
    }, "Expires"), (row == null ? void 0 : row.expires) ? /* @__PURE__ */ jsx("div", {
      sel: "expires-form"
    }, /* @__PURE__ */ jsx(InputEl, {
      sel: ".invite-users-expires-interval-input",
      attrs: { type: `number` },
      props: { value: String(row.expires.interval) },
      on: { input: (ev) => this.helpers.updateExpiresInterval(ev, row) }
    }), /* @__PURE__ */ jsx(SelectEl, {
      sel: ".invite-users-expires-unit-selector",
      attrs: {
        "menu-width": 100,
        options: Object.values(ExpiresUnit),
        "selected-option": row.expires.unit
      },
      on: { change: (ev) => this.helpers.selectExpiresUnit(ev, row) }
    })) : /* @__PURE__ */ jsx(SelectEl, {
      sel: ".invite-users-expires-mode-selector",
      attrs: {
        "menu-width": 100,
        options: Object.values(ExpiresModeOptions),
        "selected-option": ExpiresModeOptions.Never
      },
      on: { change: (ev) => this.helpers.selectExpirationMode(ev, row) }
    })))) : null, currentTab === this.helpers.TABS.TEAM ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-column"
    }, (() => {
      const numTeams = row.teamNames.length;
      const teamPlural = this.helpers.pluralize(`team`, numTeams);
      return /* @__PURE__ */ jsx(null, null, !idx ? /* @__PURE__ */ jsx("div", {
        sel: ".invite-users-title"
      }, "Teams") : null, /* @__PURE__ */ jsx(SelectEl, {
        attrs: {
          "selected-option": numTeams ? `${numTeams} ${teamPlural}` : `Select teams`,
          multiple: true,
          "show-select-all": true,
          size: ButtonSize.Large
        },
        props: {
          sections: this.helpers.getTeamSections(row)
        },
        on: {
          change: (ev) => this.helpers.toggleTeamSelected(ev, row),
          selectAll: (ev) => this.helpers.toggleAllTeamsSelected(ev, row)
        }
      }));
    })()) : null, userRows.length > 1 ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-remove-button",
      on: { click: () => this.helpers.clickedDeleteButton(row) }
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `x` }
    })) : null);
  })()), row.projectIdsToDowngrade.length ? (() => {
    const downgradedProjectsString = this.helpers.getDowngradedProjectsString(row);
    const allDowngradedProjectsString = this.helpers.getAllDowngradedProjectsString(row);
    return /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-row-error"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-error-title"
    }, "You do not have permission to assign the Project Role of Owner for all the selected projects. Admin will be assigned for ", row.projectIdsToDowngrade.length, " projects:"), row.seeAll ? /* @__PURE__ */ jsx("div", {
      sel: ".projects-list"
    }, allDowngradedProjectsString) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".project-list"
    }, downgradedProjectsString), downgradedProjectsString.length < allDowngradedProjectsString.length ? /* @__PURE__ */ jsx("div", {
      sel: ".invite-users-see-all",
      on: { click: () => this.helpers.seeAllDowngradedProjects(idx) }
    }, "See All") : null));
  })() : null);
  return /* @__PURE__ */ jsx("div", {
    sel: ".settings-screen-modal"
  }, /* @__PURE__ */ jsx(ModalEl, {
    sel: ".invite-users-modal",
    attrs: { open: this.attr(`open`) },
    on: { change: this.helpers.modalVisibilityChanged }
  }, isServiceAccount ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-header"
  }, isLoading ? /* @__PURE__ */ jsx(SpinnerEl, {
    attrs: { color: SpinnerColor.White }
  }) : `Create Service Account`), error ? /* @__PURE__ */ jsx(BannerEl, {
    sel: ".invite-users-error-banner",
    attrs: {
      theme: `warn`,
      type: BannerType.Embedded,
      "header-text": `There was an error creating the service account.`,
      "body-text": error
    }
  }) : null, !serviceAccount ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-add-users"
  }, userRows.map((row, idx) => /* @__PURE__ */ jsx(InviteUsersRow, {
    row,
    idx
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-bottom-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-modal-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: isLoading || !this.attr(`open`) || !selectedOrg || this.helpers.hasInvalidName()
    },
    on: { click: this.helpers.clickedSave }
  }, "Create"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-modal-button",
    on: { click: this.helpers.clickedCancel }
  }, "Cancel"))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".copy-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".copy-token-warning.mp-font-weight-bold"
  }, "Make sure you save the service account's secret. You will never be able to access it again."), /* @__PURE__ */ jsx("div", {
    sel: ".modal-content-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".modal-content-row"
  }, /* @__PURE__ */ jsx(CopyToClipboardEl, {
    attrs: {
      label: `Username`,
      value: serviceAccount.username
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".modal-content-row"
  }, /* @__PURE__ */ jsx(CopyToClipboardEl, {
    attrs: {
      label: `Secret`,
      value: serviceAccount.secret
    }
  })))), /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-bottom-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-modal-button",
    on: { click: this.helpers.handleClickedDone }
  }, "Done")))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-header"
  }, isLoading ? /* @__PURE__ */ jsx(SpinnerEl, {
    attrs: { color: SpinnerColor.White }
  }) : modalHeader), /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-tab-section"
  }, /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      selected: currentTab,
      theme: ToggleTheme.TabBar
    },
    on: {
      select: this.helpers.selectTab
    }
  }, /* @__PURE__ */ jsx("mp-toggle-option", {
    attrs: { value: this.helpers.TABS.PROJECT }
  }, "Invite", isSingleProject ? `` : ` to projects`), this.attr(`exclude-teams`) ? null : /* @__PURE__ */ jsx("mp-toggle-option", {
    attrs: { value: this.helpers.TABS.TEAM }
  }, "Invite to teams"), /* @__PURE__ */ jsx("mp-toggle-option", {
    attrs: { value: this.helpers.TABS.BULK }
  }, "Bulk invite"))), orgs.length > 1 ? /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-select-org"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-title"
  }, "organization"), /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      "selected-option": selectedOrg ? selectedOrg.name : `Select organization`,
      size: ButtonSize.Large
    },
    props: {
      sections: this.helpers.getOrgSections()
    },
    on: {
      change: this.helpers.selectOrg
    }
  })) : null, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-add-users",
    class: { "invite-users-hidden": !selectedOrg }
  }, selectedOrg && this.helpers.isOverSeatCount() ? /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-warning-text-container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `warning` }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-warning-text"
  }, "You have run out of seats in your organization!", ` `, this.helpers.hasBillingPerms() ? /* @__PURE__ */ jsx(null, null, "Click", /* @__PURE__ */ jsx("a", {
    sel: "#pricing-link",
    attrs: { href: `/pricing` },
    on: { click: this.helpers.trackUpsellClick }
  }, "here"), "to upgrade your plan.") : `Contact your organization's billing admin or owner to upgrade your plan.`)) : null, currentTab === this.helpers.TABS.PROJECT || currentTab === this.helpers.TABS.TEAM ? /* @__PURE__ */ jsx(null, null, selectedOrg ? userRows.map((row, idx) => /* @__PURE__ */ jsx(InviteUsersRow, {
    row,
    idx
  })) : null, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-add-another-user"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-add-another-user-button",
    on: { click: this.helpers.clickedAddMoreUser }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `plus` }
  }), "Add another user"), /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-add-another-user-alignment"
  }))) : null, currentTab === this.helpers.TABS.BULK ? /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-bulk-add-users"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-bulk-add-users-title"
  }, "File name"), /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-bulk-add-file-uploader"
  }, /* @__PURE__ */ jsx(FileUploaderEl, {
    attrs: {
      accept: `text/csv`,
      label: `Select CSV File`,
      "completed-filename": userFile && userFile.name ? userFile.name : ``,
      "enable-delete": true,
      "max-filename-chars": 120
    },
    on: { change: this.helpers.fileStatusChanged, delete: this.helpers.removeSelectedFile }
  }), userFile && userFile.error ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      "always-show": true,
      type: DisplayType.Error,
      placement: Placement.Right
    }
  }, userFile.errorMsg || `Please select a CSV file`) : null), /* @__PURE__ */ jsx("div", {
    sel: ".invite-users-bulk-add-users-subtitle"
  }, "Please follow the format of our", /* @__PURE__ */ jsx("a", {
    attrs: {
      href: `https://cdn.mxpnl.com/static/organizations/bulk_add_template.csv`,
      download: `bulk_adding_template.csv`
    }
  }, "CSV template"))) : null), /* @__PURE__ */ jsx("div", {
    sel: ".mp-modal-bottom-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-modal-button",
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: isLoading || !this.attr(`open`) || this.helpers.isOverSeatCount() || !selectedOrg
    },
    on: { click: this.helpers.clickedSave }
  }, currentTab === this.helpers.TABS.BULK ? `Upload` : `Invite`), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".mp-modal-button",
    on: { click: this.helpers.clickedCancel }
  }, "Cancel")))));
}
